//
// Functions that return a boolean about a CSS property
// --------------------------------------------------

//** Flex Wrap
var isFlexWrap = function() {
    // Default
    if(document.documentElement.style.flexWrap != undefined) {
        return true;
    }
    // Vendor prefix
    else if (document.documentElement.style.webkitFlexWrap != undefined) {
        return true;
    }
    else if (document.documentElement.style.msFlexWrap != undefined) {
        return true;
    }
    return false;
};


//
// Functions to test feature, and add class name
// --------------------------------------------------

//** Flex Wrap
var testBrowserSupport = function() {
    var bln = isFlexWrap();
    if(!bln) {
        window.location.replace("/unsupported-browser.html");
    }
};


//
// Execute tests
// --------------------------------------------------

testBrowserSupport();


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/unsupported-browser/redirect.js
 ** module id = 2
 ** module chunks = 0 1
 **/